import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";
import { FeatureFlag } from "src/constants/FEATURE_FLAGS";

/*
    Name: should-call-urgent-shifts-refactored-endpoints.
    Delete: August 1st
    Launch darkly link: https://app.launchdarkly.com/default/production/features/should-call-urgent-shifts-refactored-endpoints/targeting
*/
export const SHOULD_CALL_URGENT_SHIFTS_REFACTORED_ENDPOINTS_FF =
  "should-call-urgent-shifts-refactored-endpoints";

export type ShouldCallUrgentShiftsRefactoredEndpointsFFType = {
  frontendAdmin: boolean;
  workerMobileApp: boolean;
  urgentShiftsService: boolean;
};

type FacilityFlags = Record<FeatureFlag, string | boolean | number | unknown>;

export const LD_USER_KIND = "user";

/**
 * @deprecated
 * Consolidate `useFetchFlag` with this
 * FIXME, refactor and split identify from LD's useFlags usage
 */
export function useFeatureFlag<T>(
  flagName: FeatureFlag,
  identifyConfig: Record<string, unknown>,
  defaultValue: T
): T {
  const ldClient = useLDClient();
  const [flags, setFlags] = useState<FacilityFlags>();

  useEffect(() => {
    if (!ldClient) {
      return;
    }
    const getFlags = async () => {
      await ldClient.identify({
        ...identifyConfig,
        kind: LD_USER_KIND,
      });
      await ldClient.waitForInitialization();
      setFlags(ldClient.allFlags() as FacilityFlags);
    };
    getFlags();
    // The 'identifyConfig' object changes with each render
    // we want to re-identify LDD only when there's a change in the 'identifyConfig' value
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ldClient, JSON.stringify(identifyConfig)]);

  return (flags?.[flagName] as T) ?? defaultValue;
}
